import useTriggerPromptsOnMediaSourcesUpdate from '../services/useTriggerPromptsOnMediaSourcesUpdate'
import MediaDeviceRemovedPrompt from './MediaDeviceRemovedPrompt'
import NewMediaDevicePrompt from './NewMediaDevicePrompt'
import CrossPlatformDialog from './components/CrossPlatformDialog'

export default function NewAndRemovedMediaDevicePromptController() {
    const { newDevicePrompts, deviceRemovedPrompts, removeNewDevicePromptItem, removeDeviceRemovedPromptItem } =
        useTriggerPromptsOnMediaSourcesUpdate()

    return (
        <>
            {newDevicePrompts.map((data, i) => {
                return (
                    <CrossPlatformDialog
                        key={'MuseCrossPlatformModal:New:' + data.deviceId + data.deviceType}
                        show={!!data}
                        frameName={`Dialog:showNewDevicePrompt-${i}`}
                        onDefaultClose={() => {
                            removeNewDevicePromptItem(data)
                        }}
                        browserZIndex={22}
                    >
                        <NewMediaDevicePrompt
                            key={'NewMediaDevicePrompt:' + data.deviceId + data.deviceType}
                            newDevicePromptData={data}
                            onDefaultClose={() => {
                                removeNewDevicePromptItem(data)
                            }}
                        />
                    </CrossPlatformDialog>
                )
            })}

            {deviceRemovedPrompts.map((data, i) => {
                return (
                    <CrossPlatformDialog
                        key={'MuseCrossPlatformModal:Removed:' + data.deviceId + data.deviceType}
                        show={!!data}
                        frameName={`Dialog:showDeviceRemovedPrompt-${i}`}
                        onDefaultClose={() => removeDeviceRemovedPromptItem(data)}
                        browserZIndex={22}
                    >
                        <MediaDeviceRemovedPrompt
                            key={'MediaDeviceRemovedPrompt:' + data.deviceId + data.deviceType}
                            deviceRemovedPromptData={data}
                            onDefaultClose={() => removeDeviceRemovedPromptItem(data)}
                        />
                    </CrossPlatformDialog>
                )
            })}
        </>
    )
}
